module.exports = __webpack_public_path__ + "static/img/20-0829-detail1.26c325d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/20-0829-detail1.jpeg
// module id = NFSp
// module chunks = 0